import PropTypes from 'prop-types'
import React from 'react'

import Field from 'components/layout/form/Field'


const Annex = ({ number }) => (
  <div className="entry-group">
    <h1
      className="entry-title"
      id={`annex${number}`}
    >
      {`Annexe A${number} - I`}
    </h1>
    <Field name={`annex${number}Designation`} />
    <Field name={`annex${number}Description`} />
  </div>
)

Annex.propTypes = {
  number: PropTypes.number.isRequired
}

export default Annex
